export const fileToBase64 = (file, splitType = true) => new Promise((resolve, reject) => {
    if(file == null) return null
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(splitType ? reader.result.split(',')[1] : reader.result);
    reader.onerror = error => reject(error);
});